<template>
    <b-modal ref="view-employee-modal"
             hide-footer
             scrollable
             size="lg"
             title="Employee view">

        <div v-if="employee" class="">

            <table class="table table-bordered">
                <tr>
                    <td class="font-weight-bold">{{ $t("#TR-restaurant") }}</td>
                    <td> {{ employeeFilter.selectedRest.name }}</td>
                </tr>
                <tr>
                    <td class="font-weight-bold">{{ $t("#TR-roles") }}</td>
                    <td> {{ employeeFilter.selectedRole.name }}</td>
                </tr>
                <tr>
                    <td class="font-weight-bold">{{ $t("#TR-name") }}</td>
                    <td> {{ employee.name }}</td>
                </tr>
                <tr>
                    <td class="font-weight-bold">{{ $t("#TR-card-code") }}</td>
                    <td> {{ employee.cardCode ? employee.cardCode : '&mdash;' }}</td>
                </tr>
                <tr>
                    <td class="font-weight-bold">{{ $t("#TR-code") }}</td>
                    <td> {{ employee.code }}</td>
                </tr>
                <tr>
                    <td class="font-weight-bold">{{ $t("#TR-password") }}</td>
                    <td> {{ employee.password ? employee.password : '&mdash;' }}</td>
                </tr>
            </table>

            <div class="row">
                <div class="col-12 text-center">
                    <b-button variant="danger"
                              type="button"
                              class="mx-1"
                              @click="cancel">
                        <span class="mdi mdi-close"></span> {{ $t("#TR-cancel") }}
                    </b-button>
                    <b-button variant="primary"
                              type="button"
                              class="mx-1"
                              @click="onEdit()">
                        <span class="mdi mdi-pencil"></span> {{ $t("#TR-edit") }}
                    </b-button>
                </div>
            </div>

        </div>
    </b-modal>
</template>

<script>
import { ApiEditor } from '@/services/api';

export default {
    name: 'EmployeeView',
    components: {},
    mixins: [],
    props: {
        viewedEmployee: {
            default: () => {
                return null;
            },
            type: Object
        },
        employeeFilter: {
            default: () => {
                return null;
            },
            type: Object
        }
    },
    data() {
        return {
            employee: null
        };
    },

    async mounted() {
        await this.getEmployee();
    },

    methods: {
        async getEmployee() {
            const result = await ApiEditor.getEmployees(this.viewedEmployee.guid);
            this.employee = result.data;
        },

        onEdit() {
            this.$emit('onEdit', this.employee);
        },

        cancel() {
            this.$refs['view-employee-modal'].hide();
            this.$emit('cancelViewEdit');
        },

        openEmployeeView() {
            this.$refs['view-employee-modal'].show();
        }

    }
};
</script>

<style lang="stylus" scoped>

</style>
